import React, { FC } from "react";
// components
import Button from "src/components/ui/button";
// const
import { EVariants } from "src/constants/variants";
// theme
import { Wrapper, Content, Title, Text, ButtonContainer } from "./Submitted.styles";

interface ISubmitted {
  btnText: string;
  btnClick: () => void;
}

const Submitted: FC<ISubmitted> = ({ btnText, btnClick }) => {
  return (
    <Wrapper>
      <Content>
        <Title>Thanks for your review</Title>
        <Text>
          Your review should be live in the next 48 hours. We’ll let you know once it’s live
        </Text>
        <ButtonContainer>
          <Button variant={EVariants.PRIMARY} onClick={btnClick}>
            {btnText}
          </Button>
        </ButtonContainer>
      </Content>
    </Wrapper>
  );
};

export default Submitted;
